<template>
  <div>
    <CallHelpTel />
  </div>
  <div>
    <Search @upateShowNews="searchByKeyword"></Search>
  </div>

  <template v-for="item in employment.items" :key="item.id">
    <GrayBlock :article="item" justify="Employment" />
  </template>

  <a-pagination
    v-model:current="employment.pagination.current"
    v-model:total="employment.pagination.total"
    v-model:pageSize="employment.pagination.pageSize"
    @change="changePage"
    :style="{ fontSize: fontSize.p + 'em' }"
  ></a-pagination>
</template>

<script>
import CallHelpTel from "../components/Home/CallHelpTel.vue";
import { ref, reactive, inject } from "vue";
import GrayBlock from "../components/ContentBlock.vue";
import Search from "../components/Search.vue";
import { apiReturnWorkWithEmploymentInfo } from "@/api/api.js";
import { message } from "ant-design-vue";
import { toArticleFormat } from "@/util/article";
import { useStore } from "vuex";
export default {
  components: {
    GrayBlock,
    Search,
    CallHelpTel,
  },
  setup() {
    const store = useStore();
    let fontSize = inject("fontSize");

    let keyword = ref("");
    keyword.value = store.getters["getSearchKeyword"];
    const searchByKeyword = (str) => {
      employment.pagination.current = 1;
      keyword.value = str;
      fetchEmployment();
    };

    const employment = reactive({
      items: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
      },
    });
    const fetchEmployment = async () => {
      try {
        store.dispatch("setSearchData", {
          keyword: keyword.value,
          page: employment.pagination.current,
        });
        const {
          data: { returnWorks, currentPage, totalPage },
        } = await apiReturnWorkWithEmploymentInfo({
          keyword: keyword.value,
          page: employment.pagination.current,
        });
        const employmentItems = returnWorks.map((d) => toArticleFormat(d));

        employment.items = employmentItems;
        employment.pagination.current = currentPage;
        employment.pagination.total = totalPage * 10;
      } catch (error) {
        console.log(error);
        message.error("無法取得返國就業資訊");
      }
    };

    employment.pagination.current = store.getters["getSearchPage"];
    fetchEmployment();

    const changePage = (page, pageSize) => {
      employment.pagination.pageSize = pageSize;
      employment.pagination.current = page;
      fetchEmployment();
    };

    return { employment, changePage, searchByKeyword, fontSize };
  },
};
</script>
